/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/450-windows': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6.441 7.999c-.745-.383-1.47-.577-2.154-.577-.093 0-.187.003-.28.011a9.082 9.082 0 00-2.603.643L.001 12.942c.964-.357 1.817-.53 2.598-.53 1.263 0 2.18.472 2.937.958.359-1.217 1.219-4.158 1.476-5.036a12.34 12.34 0 00-.571-.333zm1.814 1.236l-1.413 4.909c.419.24 1.83 1.001 2.91 1.001.872 0 1.848-.223 2.982-.684l1.349-4.718c-.916.296-1.795.446-2.617.446-1.499 0-2.549-.486-3.211-.952zm-3.68-3.473c1.205.012 2.096.472 2.835.945l1.449-4.958c-.305-.175-1.106-.611-1.685-.759A5.28 5.28 0 005.968.855c-.809.015-1.694.218-2.701.622L1.885 6.33c1.013-.382 1.885-.568 2.689-.568h.002zM16 3.096c-.919.357-1.816.539-2.672.539-1.433 0-2.489-.497-3.173-.974L8.718 7.633c.965.62 2.005.936 3.096.936.89 0 1.812-.214 2.742-.636l-.003-.035.058-.014 1.39-4.788z"/>'
  }
})
